import { useIntl, defineMessage } from 'react-intl';
import { Typography, TypographyProps } from '@eventbrite/marmalade';
import React from 'react';
import { FormattedEvent } from '../../types/events';
import { EventCardTypographyLoading } from '../EventCardTypographyLoading';

type EventCardPricePropsFormattedEvent = Pick<FormattedEvent, 'formattedPriceString' | 'isFree'> & {
    isLoading?: boolean;
    hidePriceDescription?: boolean;
};

type ExtendedEventCardPriceProps = EventCardPricePropsFormattedEvent &
    Omit<TypographyProps, 'children' | 'style'>;

const FREE_COPY = defineMessage({ id: 'Free', defaultMessage: 'Free' });
const FALLBACK_COPY = defineMessage({
    id: 'Check ticket price on event',
    defaultMessage: 'Check ticket price on event',
});

/**
 * Migrated from eb-ui on 2025/02/20. [5b402ae](https://github.com/eventbrite/eb-ui/tree/5b402ae1401d9520da587c36a98b22d5094378f0/packages/attendee/event-renderer/src/components/EventCardPrice)
 */
export const EventCardPrice: React.FunctionComponent<ExtendedEventCardPriceProps> = (props) => {
    const { formattedPriceString, isFree, hidePriceDescription, isLoading, ...typographyProps } =
        props;

    const { formatMessage } = useIntl();

    if (hidePriceDescription) {
        return null;
    }

    if (isFree) {
        return <Typography {...typographyProps}>{formatMessage(FREE_COPY)}</Typography>;
    }

    if (formattedPriceString) {
        return <Typography {...typographyProps}>{formattedPriceString}</Typography>;
    }

    if (isLoading) {
        return <EventCardTypographyLoading variant={props.variant} width="120px" />;
    }

    return (
        <Typography {...typographyProps} color={'neutral-600'}>
            {formatMessage(FALLBACK_COPY)}
        </Typography>
    );
};
